module.exports = __webpack_public_path__ + "static/1-cda672b7c65972238b4684aca8ba87ba.jpeg";